import { render } from "./CookieBanner.vue?vue&type=template&id=a98cceb8&scoped=true"
import script from "./CookieBanner.vue?vue&type=script&lang=js"
export * from "./CookieBanner.vue?vue&type=script&lang=js"

import "./CookieBanner.vue?vue&type=style&index=0&id=a98cceb8&scoped=true&lang=css"

import exportComponent from "/home/user/dev/teacher-soft/datepickerDev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a98cceb8"]])

export default __exports__